import { CaretRight, DotsThree } from '@phosphor-icons/react'
import { Avatar, Popconfirm } from 'antd'
import { infoMessage } from 'api/global'
import { useRemoveGuestOrganization } from 'api/league/LeagueInvitation/LeagueInvitation'
import { getNameSignature } from 'helper/utility'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { leagueEventStore } from 'state/league/leagueEvent'
import { leagueInvitationStore } from 'state/league/leagueInvitation'
import { LeagueFinalResp } from 'types/league/league'
import ManageManagersModal from './ManageManagersModal'

const PersonsDetail: React.FC = () => {
  const { leagueData }: { leagueData: LeagueFinalResp } = leagueEventStore(
    store => ({
      leagueData: store.leagueData,
    }),
  )
  const { setInviteModal } = leagueInvitationStore(store => ({
    setInviteModal: store.setInviteModal,
  }))
  const [managersModalOpen, setManagersModalOpen] = useState(false)
  const { setLeagueData } = leagueEventStore(store => ({
    setLeagueData: store.setLeagueData,
  }))
  const { mutate: removeGuestOrg, isLoading: removingOrg } = useRemoveGuestOrganization()
  return (
    <>
      <div className="organization_details_container">
        <div className="add_organization">
          <h3 className="main-heading">Organization</h3>
          <button
            className="btn-borderles pointer"
            onClick={() => setInviteModal(true)}
          >
            Add Organization
          </button>
        </div>
        {leagueData.organization && (
          <Link
            to={`/organization/${leagueData.organization._id}`}
            className="organization"
          >
            <div className="organization-name">
              <Avatar size={40} src={leagueData.organization.photo?.post}>
                {getNameSignature(`${leagueData.organization.name}`)}
              </Avatar>
              <h4>{leagueData.organization.name}</h4>
            </div>
            <div className="settings">
              <span>Host</span>
              <DotsThree size={20} color="#000" />
            </div>
          </Link>
        )}
        {leagueData.guestOrganizations && leagueData.guestOrganizations.map(guest => {
          return (
            <div key={guest._id} className="organization">
              <Link
                to={`/organization/${guest._id}`}
                className="organization-name"
                style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}
              >
                <Avatar size={40} src={guest.photo?.post}>
                  {getNameSignature(`${guest.name}`)}
                </Avatar>
                <h4>{guest.name}</h4>
              </Link>
              <div className="settings">
                <Popconfirm
                  title="Remove organization"
                  okText="Remove"
                  okType="danger"
                  onConfirm={() =>
                    removeGuestOrg(
                      { leagueId: leagueData._id, organizationId: guest._id },
                      {
                        onSuccess: () =>
                          setLeagueData({
                            ...leagueData,
                            guestOrganizations: leagueData.guestOrganizations.filter(
                              org => org._id !== guest._id,
                            ),
                          }),
                      },
                    )
                  }
                  disabled={removingOrg}
                >
                  <DotsThree size={20} color="#000" className="pointer" onClick={e => e.preventDefault()} />
                </Popconfirm>
              </div>
            </div>
          )
        })}
      </div>

      <div className="event_manager">
        <div className="manage_button">
          <h3 className="main-heading">League managers</h3>
          <button
            className="btn-borderles pointer"
            onClick={() => setManagersModalOpen(true)}
          >
            Manage
          </button>
        </div>
        {leagueData.leagueStaff && leagueData.leagueStaff.length > 0 ? (
          leagueData.leagueStaff.map(manager => {
            return (
              <Link
                to={`/organizer/${manager._id}`}
                key={manager._id}
                className="manager"
              >
                <div className="manager-name">
                  <Avatar size={40} src={manager.photo?.post}>
                    {getNameSignature(
                      `${manager.firstName} ${manager.lastName}`,
                    )}
                  </Avatar>
                  <h4>{`${manager.firstName} ${manager.lastName}`}</h4>
                </div>
                <div className="settings">
                  <CaretRight size={20} color="#000" />
                </div>
              </Link>
            )
          })
        ) : (
          <p>No league managers added to league</p>
        )}
      </div>
      <ManageManagersModal
        open={managersModalOpen}
        onClose={() => setManagersModalOpen(false)}
      />

      <div className="event_manager">
        <div className="manage_button">
          <h3 className="main-heading">Mentors working</h3>
          <button
            className="btn-borderles pointer"
            onClick={() => infoMessage('we are working on it')}
          >
            Manage
          </button>
        </div>
        {leagueData.mentorsWorking && leagueData.mentorsWorking.length > 0 ? (
          leagueData.mentorsWorking.map(mentor => {
            return (
              <Link
                to={`/mentors/${mentor._id}`}
                key={mentor._id}
                className="manager"
              >
                <div className="manager-name">
                  <Avatar size={40} src={mentor.photo?.post}>
                    {getNameSignature(`${mentor.firstName} ${mentor.lastName}`)}
                  </Avatar>
                  <h4>{`${mentor.firstName} ${mentor.lastName}`}</h4>
                </div>
                <div className="settings">
                  <CaretRight size={20} color="#000" />
                </div>
              </Link>
            )
          })
        ) : (
          <p>No league managers added to league</p>
        )}
      </div>
    </>
  )
}

export default PersonsDetail
